import { useState, useRef, useCallback } from 'react';
import { useScrollDirection } from './useScrollDirection';
import { useWindowScroll } from './useWindowScroll';

type UseStickyHeaderReturn = {
    /** Ссылка на элемент */
    headerRef: React.RefObject<HTMLDivElement | null>;
    /** Элемент прилип к верху экрана */
    isSticky: boolean;
    /** Нужно ли скрыть элемент (скролл вниз + прилип) */
    shouldHide: boolean;
};

export const useStickyHeader = (): UseStickyHeaderReturn => {
    const headerRef = useRef<HTMLDivElement>(null);

    const [isSticky, setIsSticky] = useState(false);

    const checkIfStuck = useCallback(() => {
        if (headerRef.current) {
            const rect = headerRef.current.getBoundingClientRect();

            const newIsStuck = rect.top <= 0;

            if (newIsStuck !== isSticky) {
                setIsSticky(newIsStuck);
            }
        }
    }, [isSticky]);

    const { isScrollingDown } = useScrollDirection();

    const shouldHide = isSticky && isScrollingDown;

    useWindowScroll(checkIfStuck, 0, { passive: true });

    return { headerRef, isSticky, shouldHide };
};
